import { StorageItemsFilterValue } from '_data/types/project';

export const PROJECT_ROLE = {
  EDIT: 1,
  READ_ONLY: 2,
};

export const PROJECT_INVITE_STATUS = {
  CONFIRMED: 1,
  PENDING: 2,
};

const USER_ROLES = (window as any).dictionaries.roles.reduce(
  (acc, { label, value }) => ({ ...acc, [value]: label, [label]: value }),
  {
    Owner: 0,
    0: 'Owner',
  }
);

export { USER_ROLES };

const SHARING_TYPES = (window as any).dictionaries.sharingTypes.reduce(
  (acc, { label, value }) => ({ ...acc, [value]: label, [label]: value }),
  {}
);

export { SHARING_TYPES };

export const PROJECT_TYPE = {
  ARTEC_STUDIO_PROJECT: 1,
  LEO_PROJECT: 2,
  ARTEC_CLOUD: 3,
  FOBOS: 4,
};

export const INVITE_STATUS = {
  CONFIRMED: 1,
  PENDING: 2,
};

export const SCANNER_TYPES = {
  hasMicro: 1,
  hasRay: 2,
};

export enum EOptionType {
  Link,
  Filter,
}

interface IFilterOption {
  type: EOptionType;
  value: {
    filters: StorageItemsFilterValue | 'sharing_links';
  };
  caption: string;
  path?: string;
  pathname?: string;
}

export const filterOptions: IFilterOption[] = [
  {
    type: EOptionType.Filter,
    value: { filters: StorageItemsFilterValue.All },
    caption: 'All Projects',
    path: '/',
  },
  { type: EOptionType.Filter, value: { filters: StorageItemsFilterValue.My }, caption: 'My Projects', path: '/' },
  {
    type: EOptionType.Filter,
    value: { filters: StorageItemsFilterValue.SharedWithMe },
    caption: 'Shared with me',
    path: '/',
  },
  {
    type: EOptionType.Link,
    value: { filters: 'sharing_links' },
    caption: 'My shared models',
    pathname: '/my_shared_models',
  },
  { type: EOptionType.Filter, value: { filters: StorageItemsFilterValue.Deleted }, caption: 'Trash', path: '/' },
];
